import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid
} from "@mui/material";

const AssetDialogs = ({
  // Статус
  statusDialogOpen,
  setStatusDialogOpen,
  newStatusName,
  setNewStatusName,
  onCreateStatus,
  
  // Пункт проката
  rentalPointDialogOpen,
  setRentalPointDialogOpen,
  newRentalPointName,
  setNewRentalPointName,
  newRentalPointAddress,
  setNewRentalPointAddress,
  onCreateRentalPoint,
  
  // Тариф
  tariffDialogOpen,
  setTariffDialogOpen,
  newTariff,
  setNewTariff,
  onCreateTariff
}) => {
  return (
    <>
      {/* Создание статуса */}
      <Dialog open={statusDialogOpen} onClose={() => setStatusDialogOpen(false)}>
        <DialogTitle>Создать новый статус</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Название статуса"
            fullWidth
            variant="outlined"
            value={newStatusName}
            onChange={(e) => setNewStatusName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStatusDialogOpen(false)}>
            Отмена
          </Button>
          <Button onClick={onCreateStatus} variant="contained">
            Создать
          </Button>
        </DialogActions>
      </Dialog>

      {/* Создание пункта проката */}
      <Dialog open={rentalPointDialogOpen} onClose={() => setRentalPointDialogOpen(false)}>
        <DialogTitle>Создать новый пункт проката</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Название пункта проката"
            fullWidth
            variant="outlined"
            value={newRentalPointName}
            onChange={(e) => setNewRentalPointName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Адрес"
            fullWidth
            variant="outlined"
            value={newRentalPointAddress}
            onChange={(e) => setNewRentalPointAddress(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRentalPointDialogOpen(false)}>
            Отмена
          </Button>
          <Button onClick={onCreateRentalPoint} variant="contained">
            Создать
          </Button>
        </DialogActions>
      </Dialog>

      {/* Создание тарифа */}
      <Dialog open={tariffDialogOpen} onClose={() => setTariffDialogOpen(false)}>
        <DialogTitle>Создать новый тариф</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoFocus
                margin="dense"
                label="Название тарифа"
                fullWidth
                variant="outlined"
                value={newTariff?.name || ""}
                onChange={(e) => setNewTariff(prev => ({ ...prev, name: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                margin="dense"
                label="Цена"
                type="number"
                fullWidth
                variant="outlined"
                value={newTariff?.price || ""}
                onChange={(e) => setNewTariff(prev => ({ ...prev, price: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                margin="dense"
                label="Дни"
                type="number"
                fullWidth
                variant="outlined"
                value={newTariff?.days || ""}
                onChange={(e) => setNewTariff(prev => ({ ...prev, days: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                margin="dense"
                label="Часы"
                type="number"
                fullWidth
                variant="outlined"
                value={newTariff?.hours || ""}
                onChange={(e) => setNewTariff(prev => ({ ...prev, hours: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                margin="dense"
                label="Минуты"
                type="number"
                fullWidth
                variant="outlined"
                value={newTariff?.minutes || ""}
                onChange={(e) => setNewTariff(prev => ({ ...prev, minutes: e.target.value }))}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTariffDialogOpen(false)}>
            Отмена
          </Button>
          <Button onClick={onCreateTariff} variant="contained">
            Создать
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AssetDialogs;
